import React, { Component } from 'react';
import { Link } from 'react-router';
import { defineMessages, injectIntl } from 'react-intl';

import BillingCurrentMonth from './components/BillingCurrentMonth';
import BillingDownloadList from './components/BillingDownloadList';
import NavBarConfig from '../../components/NavBarConfig';
import nfetch from '../../actions/nfetch';

const messages = defineMessages({
  BILLINGS: {
    id: 'CompanyBillingPage.BILLINGS',
    defaultMessage: 'Einzelverbindungsnachweise',
  },
  BACK: {
    id: 'CompanyBillingPage.BACK',
    defaultMessage: 'Zurück',
  },
  CURRENT_MONTH: {
    id: 'CompanyBillingPage.CURRENT_MONTH',
    defaultMessage: 'Einzelverbindungsnachweis des laufenden Monats',
  },
});

class CompanyBillingPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: ''
    };
  }

  handleSearchChange = (e) => {
    this.setState({ filter: e.target.value });
  }

  render() {
    const {
      billing: { connections, downloads },
      company,
      routes,
      intl: { formatMessage },
    } = this.props;
    const { filter } = this.state;

    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
        <NavBarConfig currentRouteName={routes[routes.length - 1].name} />
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '12px', color: 'var(--text-color)' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-file-text-o" />
              </div>
              <div>
                {formatMessage(messages.BILLINGS)}
                <span style={{ display: 'block', fontSize: '14px', fontWeight: 'normal', color: 'var(--text-muted)', marginTop: '4px' }}>
                  {company.name}
                </span>
              </div>
            </h2>
            
            <div style={{ position: 'relative' }}>
              <i className="fa fa-search" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
              <input
                style={{ padding: '0 16px 0 40px', height: '38px', boxSizing: 'border-box', borderRadius: '8px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--input-text)', outline: 'none', width: '250px', fontSize: '14px' }}
                type="text"
                placeholder="Suchen..."
                value={filter}
                onChange={this.handleSearchChange}
              />
            </div>
          </div>

          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', padding: '32px', overflow: 'hidden' }}>
            <div style={{ marginBottom: '40px' }}>
              <BillingDownloadList downloads={downloads} companyId={company.id} filter={filter} />
            </div>

            <h3 style={{ margin: '0 0 16px 0', fontSize: '20px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.CURRENT_MONTH)}
            </h3>
            <BillingCurrentMonth connections={connections} filter={filter} />
          </div>

        </div>
      </div>
    );
  }
}

const CompanyBillingPageNfetch = nfetch(
  ({ params }) => ({ billing: { url: `/api/company/${params.companyId}/billing` } }),
)(CompanyBillingPageComponent);

export default injectIntl(CompanyBillingPageNfetch);
